<template>
  <header
    class="border-b-sm sticky top-0 flex justify-center border-blue-400 bg-blue-50"
  >
    <div
      class="py-xxs px-xs w-content gap-xs flex h-full flex-initial items-center justify-between"
    >
      <div v-if="!form" class="flex h-full items-center">
        <NuxtLink to="/">
          <img
            class="h-13.25 w-full"
            src="~/assets/images/logos/reseau-agenda.svg"
            alt="Retour à l'accueil de Agenda.org, le réseau des agendas"
          />
        </NuxtLink>
      </div>

      <NuxtLink v-else to="/" class="h-13.25">
        <Icon name="app:agenda" class="text-[53px]" />
      </NuxtLink>

      <div
        v-if="form"
        class="flex h-13.25 grow transition-all starting:opacity-0"
        :class="form ? 'opacity-100' : 'opacity-0'"
      >
        <slot> </slot>
      </div>

      <div class="gap-xs laptop:gap-md flex items-center">
        <ClientOnly>
          <NuxtLink
            to="/compte"
            class="gap-xxs flex flex-col items-center justify-center"
          >
            <AppHeaderDefaultAvatar
              v-if="authStore.isControlled"
              class="m-0.75"
            />

            <Icon v-else name="fa6-solid:user" class="m-1.25 text-xl" />

            <span class="max-laptop:hidden">
              {{ authStore.isControlled ? "Mon compte" : "Me connecter" }}
            </span>
          </NuxtLink>
        </ClientOnly>

        <div v-if="!form" class="gap-xs laptop:flex-col max-laptop:mr-xxs flex">
          <NuxtLink
            class="gap-xxs flex flex-col items-center justify-center"
            to="https://www.facebook.com/ReseauDesAgendas"
          >
            <Icon name="app:square-facebook" class="text-3xl" />
            <span class="sr-only">Retrouvez-nous sur Facebook</span>
          </NuxtLink>

          <NuxtLink
            class="gap-xxs flex flex-col items-center justify-center"
            to="https://www.instagram.com/reseaudesagendas"
          >
            <Icon name="app:square-instagram" class="text-3xl" />
            <span class="sr-only">Retrouvez-nous sur Instagram</span>
          </NuxtLink>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
defineProps({
  form: {
    type: Boolean,
    default: false,
  },
});

const authStore = useAuthStore();
</script>
